export enum ErrorPageTypes {
  NOT_FOUND = 'NOT_FOUND',
  SOMETHING_WENT_WRONG = 'SOMETHING_WENT_WRONG',
  FORBIDDEN = 'FORBIDDEN',
  ACCESS_FORBIDDEN = 'ACCESS_FORBIDDEN', // to be described why we need two forbidden pages
}
